import styled, { keyframes } from 'styled-components'

const spinAnimation = keyframes`
  from { transform:rotate(0deg);  }
  to   { transform:rotate(360deg); }
`

export const Spin = styled.img`
  animation: ${spinAnimation} 1000ms linear infinite;
`
